import { computed } from "vue"
import { useStore } from "vuex"

const useSubsidiaries = () => {
    const store = useStore()

    const getSubsidiariesList = () => {
        const res = store.dispatch('subsidiaries/getSubsidiaries')
        return res
    }

    const setSubsidiarySelect = (subsidiary) => {
        const res = store.commit('subsidiaries/setSubsidiarySelect', subsidiary)
        return res
    }

    return {
        setSubsidiarySelect,
        getSubsidiariesList,
        subsidiariesSelectable: computed(() => store.getters['subsidiaries/subsidiariesSelectable']),
        subsidiarySelect: computed(() => store.getters['subsidiaries/subsidiarySelect']),
    }
}

export default useSubsidiaries